export enum DestinationDatabase {
    RECOGNITION = 'tdm_redshift',
    BULK_UPLOAD = 'batch_mysql',
    BONUS_REISSUE = ''
}

export enum FileUploadSource {
    CSP = 'CSP'
}

export enum COLUMN_VALIDATION {
    OPERATING_COUNTRY = 'country_response',
    LEVEL = 'level_response'
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/file-upload.enum.ts